import { api, Tags } from "@state/apiSlice";

import type {LoginParams, LoginResponse, SetPasswordParams} from "@hz/stealthy-gmc-cloaker-common/api-types/auth"
import type { RegisterParams, RegisterResponse } from "@hz/stealthy-gmc-cloaker-common/api-types/auth";

const authRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, LoginParams>({
      query: (data) => ({
        url: "/auth/login",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
        method: "POST",
      }),
    }),
    register: build.mutation<RegisterResponse, RegisterParams>({
      query: (data) => ({
        url: "/auth/register",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    setPassword: build.mutation<{success: boolean}, SetPasswordParams>({
      query: ({password, token}) => ({
        url: "/auth/set-password",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          token,
          password,
        },
        method: "POST",

      }),
    }),
    requestResetPassword: build.mutation<{success: boolean}, {email: string}>({
      query: ({email}) => ({
        url: "/auth/request-password-reset",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          email,
        },
        method: "POST",

      }),
    }),
  }),
});

export default authRequestsSlice;
